import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import userReducer from "./user";
import { metaSlice } from "./meta";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        meta: metaSlice.reducer,
    },
    // Ignore non-serializable values in actions
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

export default store;
